export { default } from '@shikijs/langs/rust'
